module.exports = __webpack_public_path__ + "static/media/bottom_shape_3a.344fe5c1.svg";